var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('PageHeader',{attrs:{"add":{icon: 'bx bx-add-to-queue bx-tada', title: 'general.new', link: 'manage-setting-service-add'},"title":_vm.$t('manage.service.text')}}),_c('List',{attrs:{"dataList":_vm.data,"updating":_vm.fetchingStats,"navigate":_vm.pageNavigate,"formats":[{name:'price', type: 'currency'}],"fields":[ 
          ("name: " + (_vm.$t('manage.service.name'))),
          ("name_en: " + (_vm.$t('manage.name_en'))),
          ("service_type: " + (_vm.$t('manage.service-type.text'))),
          ("price: " + (_vm.$t('manage.service-type.text'))) ],"deletes":[_vm.deleted, null],"edit":{link: 'manage-setting-service-edit'},"filter":{
          search: ['mg_services.name','mg_services.name_en'],
          dropdown: [{
            title: 'manage.service.type',
            field: 'mg_services.service_type_id',
            data: this.typeList.data,
            width: 2
          }]
        }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }